/**
 * Normalizes scalars returned by MDM (often string; postal code may be number, etc.).
 */
export function mdmScalarToTrimmedString(value: unknown): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return "";
}
